<script setup>
import { ref, watch, nextTick } from 'vue';
import AddedProduct from '@/components/Right/AddedProduct.vue';
import { useOrderStore } from '@/stores/OrderStore';

const orderStore = useOrderStore();
const scrollContainer = ref(null);
const addedProductRef = ref(null);

watch(
  () => orderStore.state.orderItems.length,
  (newLength, oldLength) => {
    if (newLength > oldLength) {
      nextTick(() => {
        if (scrollContainer.value && addedProductRef.value?.$el) {
          scrollContainer.value.scrollTo({
            top: addedProductRef.value.$el.scrollHeight,
            behavior: 'smooth'
          });
        }
      });
    }
  }
);
</script>

<template>
    <div ref="scrollContainer" class="bg-white rounded-tl-2xl rounded-tr-2xl h-[calc(100vh-30rem)] overflow-y-auto relative">
        <!-- Manual Order Flag/Badge -->
        <!-- <div v-show="orderStore.state.addManualOrder" 
          class="absolute top-0 left-[-4] z-10 bg-purple-600 text-white text-xs font-semibold px-3 py-1.5 rounded shadow-lg flex items-center gap-1.5 transform  origin-top-left">
          <i class="pi pi-shopping-cart" style="font-size: 12px;"></i>
          <span>MO</span>
        </div> -->
        <AddedProduct ref="addedProductRef" />
    </div>
</template>

<style scoped>

</style>